import { render, staticRenderFns } from "./epros-details.vue?vue&type=template&id=f55b4156&scoped=true&"
import script from "./epros-details.vue?vue&type=script&lang=js&"
export * from "./epros-details.vue?vue&type=script&lang=js&"
import style0 from "./epros-details.vue?vue&type=style&index=0&id=f55b4156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55b4156",
  null
  
)

component.options.__file = "epros-details.vue"
export default component.exports